import {
  asClause,
  ensureTerminal,
  properWords,
  stripEnd,
  tidy,
  tidySeams,
} from "@/lib/tool-kit/essay/sentence";

export interface IntroductionInput {
  context: string;
  hook: string;
  thesis: string;
}

export interface IntroductionFrames {
  background: string;
  thisEssayArgues: string;
  toUnderstand: string;
}

const ENGLISH = /^en(?:-|$)/i;

/**
 * Builds the four-sentence introduction. The context and thesis move into the middle of
 * a frame ("it helps to know that …"), so their first letter is lowered only in English
 * and only when the first word does not read as a name (NASA, I, a run of
 * capitalised words, a word the writer capitalises elsewhere). Other locales keep the
 * text as typed, because lowering the first letter would break German nouns and names
 * in every language.
 */
export function buildIntroduction(
  input: IntroductionInput,
  frames: IntroductionFrames,
  locale: string
): string {
  const proper = properWords([input.hook, input.context, input.thesis]);
  const clause = (text: string) =>
    ENGLISH.test(locale) ? asClause(text, proper) : stripEnd(tidy(text));
  return [
    ensureTerminal(tidy(input.hook)),
    tidySeams(`${frames.toUnderstand}${clause(input.context)}.`),
    frames.background,
    tidySeams(`${frames.thisEssayArgues}${clause(input.thesis)}.`),
  ].join(" ");
}
